import React, { useEffect, useState, useMemo, useRef, useContext } from "react";
import { UserContext } from "../context/User";
import TinderCard from "react-tinder-card";
import { Modal, ActionIcon, Button, createStyles } from "@mantine/core";
import "../styles/Home.css";
import { Heart, X } from "phosphor-react";
import { Tooltip } from "@mantine/core";
import { petdata } from "../data";
import axios from "axios";
import { useHistory } from "react-router-dom";
const useStyles = createStyles((theme) => ({
  title: {
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize: 35,
    lineHeight: 1.2,
    fontWeight: 800,

    [theme.fn.smallerThan("xs")]: {
      fontSize: 28,
    },
  },
}));
function Home() {
  const { classes } = useStyles();
  const history = useHistory();
  const { UserInfo } = useContext(UserContext);
  const [opened, setOpened] = useState(false);
  const matches = [4, 12, 16, 28, 32, 40, 44, 52, 56, 64, 68, 76];
  const [liked, setliked] = useState([]);
  const [db, setdb] = useState(petdata);
  const [matchinfo, setmatchinfo] = useState([]);
  useEffect(() => {
    axios
      .get("https://swipett.herokuapp.com/likeuser/likedusers", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setliked(res.data.likedusers);
      });
  }, []);

  const [currentIndex, setCurrentIndex] = useState(db.length - 1);
  const [lastDirection, setLastDirection] = useState();
  // used for outOfFrame closure
  const currentIndexRef = useRef(currentIndex);

  const childRefs = useMemo(
    () =>
      Array(db.length)
        .fill(0)
        .map((i) => React.createRef()),
    []
  );

  const updateCurrentIndex = (val) => {
    setCurrentIndex(val);
    currentIndexRef.current = val;
  };

  const canGoBack = currentIndex < db.length - 1;

  const canSwipe = currentIndex >= 0;

  // set last direction and decrease current index
  const swiped = (direction, nameToDelete, index) => {
    console.log(db[index], direction);
    if (direction === "right") {
      axios
        .post(
          "https://swipett.herokuapp.com/likeuser",
          {
            likedid: db[index].id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          if (matches.includes(db[index].id)) {
            setmatchinfo(db[index]);
            setOpened(true);
          }
        });
    }
    setLastDirection(direction);
    updateCurrentIndex(index - 1);
  };

  const outOfFrame = (name, idx) => {
    console.log(`${name} (${idx}) left the screen!`, currentIndexRef.current);
    // handle the case in which go back is pressed before card goes outOfFrame
    currentIndexRef.current >= idx && childRefs[idx].current.restoreCard();
    // TODO: when quickly swipe and restore multiple times the same card,
    // it happens multiple outOfFrame events are queued and the card disappear
    // during latest swipes. Only the last outOfFrame event should be considered valid
  };

  const swipe = async (dir) => {
    if (canSwipe && currentIndex < db.length) {
      await childRefs[currentIndex].current.swipe(dir); // Swipe the card!
    }
  };

  // increase current index and show card
  const goBack = async () => {
    if (!canGoBack) return;
    const newIndex = currentIndex + 1;
    updateCurrentIndex(newIndex);
    await childRefs[newIndex].current.restoreCard();
  };

  return (
    <div>
      <div className="cardContainer">
        {db.map((character, index) => (
          <TinderCard
            preventSwipe={["up", "down"]}
            ref={childRefs[index]}
            className="swipe"
            key={character.id}
            onSwipe={(dir) => swiped(dir, character.name, index)}
            onCardLeftScreen={() => outOfFrame(character.name, index)}
          >
            <div
              style={{ backgroundImage: `url(${character.url})` }}
              className="card"
            >
              <h3>{character.name}</h3>
            </div>
          </TinderCard>
        ))}
        <div className="cardbuttoncontainer">
          <div className="cardbuttons">
            <Tooltip position="bottom" withArrow label="reject">
              <ActionIcon
                onClick={() => swipe("left")}
                color="red"
                size={45}
                radius={"50%"}
                variant="light"
              >
                <X size={20} color="red" weight="bold" />
              </ActionIcon>
            </Tooltip>

            <Tooltip position="bottom" withArrow label="Like">
              <ActionIcon
                onClick={() => swipe("right")}
                size={45}
                radius={"50%"}
                color="green"
                variant="light"
              >
                <Heart size={25} color="green" weight="fill" />
              </ActionIcon>
            </Tooltip>
          </div>
        </div>
      </div>
      <Modal
        withCloseButton={false}
        opened={opened}
        onClose={() => setOpened(false)}
      >
        {/* {matchinfo.name} */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "30px",
          }}
          className="modal"
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: "40px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className={classes.title}>Congratulations </div>
            <div className={classes.title}>
              It's a{" "}
              <span
                style={{
                  textDecoration: "underline",
                  textDecorationColor: "gold",
                  textDecorationThickness: "7px",
                }}
                className={classes.title}
              >
                {" "}
                match!
              </span>
            </div>
          </div>
          <div style={{ display: "flex", gap: "20px" }}>
            <img
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
              }}
              src={matchinfo.url}
              alt=""
            />
            <img
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
              }}
              src={
                UserInfo.avatar
                  ? UserInfo.avatar
                  : `https://ui-avatars.com/api/?background=008AB8&color=fff&name=${UserInfo.username.charAt(
                      0
                    )}&size=128`
              }
              alt=""
            />
          </div>
          <div style={{ fontWeight: "bold", fontSize: "25px" }}>
            {matchinfo.name}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "10px",
              padding: "0 100px",
            }}
          >
            <Button variant="outline">message</Button>
            <Button
              onClick={() => {
                history.push("/profile");
              }}
            >
              Your Profile
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Home;
